<template>
  <div class="concept">
    <div id="head-page" class="contact parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/cloud.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.3"><img class="" src="@/assets/images/head/echelle.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/papillon.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

   <div class="grid-container content-page">
      <div class="grid-x grid-container-padding">
        <div class="small-12 medium-4 medium-offset-4 cell center">

          <title-page attrpage="" baseline="Réinitialisez-le !">Mot de passe oublié</title-page>

          <div class="form filrouge">
            <div class="line">
              <div :class="{error: errors.indexOf('email') !== -1}">
                <label for="email">Indiquez votre email*</label>
                <input type="email" name="email" id="email" v-model="email" required />
              </div>
              <input class="button btnPush" name="submit" type="submit" value="Valider" @mouseover="verify" @click="send"/>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import TitlePage from '@/components/TitlePage'
  export default {
    components: { TitlePage },
    data () {
      return {
        email: '',
        errors: []
      }
    },
    methods: {
      ...mapActions(['sendResetPasswordInstructions', 'addNotice']),
      verify (field) {
        this.errors = []
        if (!this.email) {
          this.errors.push("email")
        }
      },
      async send (e) {
        e.preventDefault();
        this.verify();
        if (this.errors.length > 0) {
          return false
        }

        try {
          this.sendResetPasswordInstructions({ email: this.email })
          this.addNotice({ message: 'Un mail avec des instructions permettant de réinitialiser votre mot de passe a été envoyé.' })
          this.$router.push({name: 'home'})
        } catch(ex) {
          throw ex;
        }
      }
    },
  }
</script>
